// import { useSetPageTitle } from "src/hooks/useSetPageTitle";
import { AppLayout } from "src/components/layout/app-layout";
import ManageClientsTab from "./tabs/manage-clients.tab";
import ManageAccountsTab from "./tabs/manage-accounts.tab";
import ManageCampaignsTab from "./tabs/manage-campaigns.tab";
import { useNavigate, useParams } from "react-router-dom";

const ClientManagementPage = () => {
  const navigate = useNavigate();
  const { tab } = useParams<{ tab?: string }>();

  const clientManagementTabs = [
    {
      id: '',
      key: 'clients',
      label: 'Clients',
    },
    {
      id: 'manage-accounts',
      key: 'accounts',
      label: 'Accounts',
    },
    {
      id: 'manage-campaigns',
      key: 'campaigns',
      label: 'Campaigns',
    },
  ];

  const validTabs = clientManagementTabs.map(tab => tab.id);
  type TabType = typeof validTabs[number];

  const currentTab: TabType = validTabs.includes(tab as TabType)
    ? (tab as TabType)
    : '';

  const handleTabChange = (tabId: string) => {
    navigate(`/manage-clients/${tabId}`);
  };

  return (
    <AppLayout
      activePage="/client-management"
      navbarProps={{
        tabs: clientManagementTabs,
        activeTab: currentTab,
        onTabChange: handleTabChange,
      }}
    >

      <div className="h-[calc(100vh-8rem)]">
        {currentTab === '' && <ManageClientsTab />}
        {currentTab === 'manage-accounts' && <ManageAccountsTab />}
        {currentTab === 'manage-campaigns' && <ManageCampaignsTab />}
      </div>

    </AppLayout>
  );
};

export default ClientManagementPage;
